import { permissionGuard } from './permission.guard';

/**
 * Gates the participants area. Holders of `participants.import` (Reviewers, Admin) reach it to
 * import the FirmView master; holders of `participants.transfer` reach it to move activity
 * between participants. Widen this if a read-only view lands.
 */
export const participantsGuard = permissionGuard(
  (p) => p.has('participants.import') || p.has('participants.transfer'),
);
